import { atom } from 'jotai';

import { DeliveryMethod } from '../types';
import { isAlternativeEligibility } from '../utils';
import { deliveryMethodAtom } from './deliveryMethodAtom';
import { selectedDeviceTypeAsyncAtom } from './selectedDeviceTypeAsyncAtom';
import { selectedRepairsAsyncAtom } from './selectedRepairsAsyncAtom';

export const deliveryMethodAsyncAtom = atom(async (get) => {
  const selectedRepairs = await get(selectedRepairsAsyncAtom);
  const deliveryMethod = get(deliveryMethodAtom);
  const deviceType = await get(selectedDeviceTypeAsyncAtom);

  return deliveryMethod === DeliveryMethod.ComeToMe &&
    !isAlternativeEligibility(selectedRepairs, deviceType)
    ? DeliveryMethod.VisitStore
    : deliveryMethod;
});
